module.exports = __webpack_public_path__ + "static/media/slider-nfl.6dac51d9.jpg";